import React from 'react';
import { FacebookIcon, InstagramIcon, MessageCircleIcon, PhoneIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { BUSINESS } from '../data/i18n';
import { services } from '../data/services';
import { Logo } from './Logo';
const quickLinks = [{
  href: '#services',
  labelKey: 'nav.services'
}, {
  href: '#gallery',
  labelKey: 'nav.gallery'
}, {
  href: '#about',
  labelKey: 'nav.about'
}, {
  href: '#faq',
  labelKey: 'faq.title'
}];
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="w-full bg-navy-950 pb-10 pt-16 text-white" data-id="element-102" data-mp="37xxily2sakn">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-103" data-mp="3ldamrdmenziu">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4" data-id="element-104" data-mp="3qdf393nbcu92">
          <div data-id="element-105" data-mp="3qfjey7rgexjw">
            <Logo variant="light" data-id="element-106" data-mp="29z6uqczdolgf" />
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-white/65" data-id="element-107" data-mp="29y5g5yj5lgty">
              {t('footer.tagline')}
            </p>
            <a href={BUSINESS.phoneHref} className="mt-5 inline-flex items-center gap-2 font-display text-lg font-extrabold text-white hover:text-amber-400" data-id="element-108" data-mp="2ezl4q0kji5h3">
              <PhoneIcon className="h-4 w-4 text-amber-400" aria-hidden="true" data-id="element-109" data-mp="3gcaahgjsihhj" />
              {BUSINESS.phoneDisplay}
            </a>
          </div>

          <nav aria-label={t('footer.quick')} data-id="element-110" data-mp="3q83q58st2r3j">
            <h3 className="font-display text-sm font-bold uppercase tracking-wide text-amber-400" data-id="element-111" data-mp="3q7bz8ba5lhjl">
              {t('footer.quick')}
            </h3>
            <ul className="mt-4 flex flex-col gap-2.5" data-id="element-112" data-mp="34gtn85h8b3d">
              {quickLinks.map(link => <li key={link.href} data-id="element-113" data-mp="ht3ajear5awp">
                  <a href={link.href} className="text-sm text-white/70 transition-colors duration-150 ease-smooth hover:text-white" data-id="element-114" data-mp="hs1yb6i02ide">
                    {t(link.labelKey)}
                  </a>
                </li>)}
              <li data-id="element-115" data-mp="mthk50s04swu">
                <a href="#testimonials" className="text-sm text-white/70 transition-colors duration-150 ease-smooth hover:text-white" data-id="element-116" data-mp="mptpfyatm0gj">
                  {t('footer.testimonials')}
                </a>
              </li>
            </ul>
          </nav>

          <nav aria-label={t('footer.services')} data-id="element-117" data-mp="13r7of4scwwqd">
            <h3 className="font-display text-sm font-bold uppercase tracking-wide text-amber-400" data-id="element-118" data-mp="18k92xboniu9f">
              {t('footer.services')}
            </h3>
            <ul className="mt-4 flex flex-col gap-2.5" data-id="element-119" data-mp="1cnyqpyxi57te">
              {services.map(service => <li key={service.id} data-id="element-120" data-mp="1hmig69bb11qi">
                  <a href="#services" className="text-sm text-white/70 transition-colors duration-150 ease-smooth hover:text-white" data-id="element-121" data-mp="1mjimmlc2g6i5">
                    {t(service.titleKey)}
                  </a>
                </li>)}
            </ul>
          </nav>

          <div data-id="element-122" data-mp="3tb1bs5hz4ym9">
            <h3 className="font-display text-sm font-bold uppercase tracking-wide text-amber-400" data-id="element-123" data-mp="3tai199unlci9">
              {t('footer.contact')}
            </h3>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm text-white/70" data-id="element-124" data-mp="25o59chqqnpc5">
              <li data-id="element-125" data-mp="21mk159p5fz8a">
                <a href={`mailto:${BUSINESS.email}`} className="break-all hover:text-white" data-id="element-126" data-mp="21m0ifqrod6t7">
                  {BUSINESS.email}
                </a>
              </li>
              <li data-id="element-127" data-mp="1wlw2q2ylcg41">{BUSINESS.area}</li>
              <li data-id="element-128" data-mp="2te9dqrbr3t47">{t('contact.hours1')}</li>
              <li data-id="element-129" data-mp="2tbvioih2mgwn">{t('contact.hours2')}</li>
            </ul>

            <div className="mt-5" data-id="element-130" data-mp="2pdfq7z280gbu">
              <span className="sr-only" data-id="element-131" data-mp="2pa9z6ea174dh">{t('footer.social')}</span>
              <ul className="flex items-center gap-3" data-id="element-132" data-mp="2kc8czkhb6oxs">
                <li data-id="element-133" data-mp="2fe6xf9j3d7r2">
                  <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="flex h-10 w-10 items-center justify-center rounded-lg bg-white/10 text-white transition-colors duration-150 ease-smooth hover:bg-white/20" data-id="element-134" data-mp="2feq8c6abqvvl">
                    <InstagramIcon className="h-5 w-5" aria-hidden="true" data-id="element-135" data-mp="2wm7nj6uhuo5e" />
                  </a>
                </li>
                <li data-id="element-136" data-mp="2ivuf73dox7fj">
                  <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="flex h-10 w-10 items-center justify-center rounded-lg bg-white/10 text-white transition-colors duration-150 ease-smooth hover:bg-white/20" data-id="element-137" data-mp="2iwcg4dbas9ts">
                    <FacebookIcon className="h-5 w-5" aria-hidden="true" data-id="element-138" data-mp="31khhxf8e9kpy" />
                  </a>
                </li>
                <li data-id="element-139" data-mp="36jcdlhrgn3rh">
                  <a href={BUSINESS.whatsappHref} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp" className="flex h-10 w-10 items-center justify-center rounded-lg bg-whats-500 text-white transition-colors duration-150 ease-smooth hover:bg-whats-600" data-id="element-140" data-mp="36mqeelkh74wt">
                    <MessageCircleIcon className="h-5 w-5" aria-hidden="true" data-id="element-141" data-mp="1iml8bwd0ixxn" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-2 border-t border-white/10 pt-6 sm:flex-row sm:items-center sm:justify-between" data-id="element-142" data-mp="1rouhahsmuj8x">
          <p className="text-xs text-white/55" data-id="element-143" data-mp="13vvwcrrq9esq">{t('footer.rights')}</p>
          <p className="text-xs text-white/55" data-id="element-144" data-mp="zxofzy16efi2">{t('footer.licensed')}</p>
        </div>
      </div>
    </footer>;
}